import useStores from 'shared/hooks/use-stores';
export default function useUI() {
    var UI = useStores().UI;
    return UI;
}
